import * as actions from '../actions/lsSupplierManagement';
import * as types from '../types/smSupplierManagement';
// @ts-ignore
import _ from 'lodash';

const initState: types.SupplierManagementState = {
  detail: {
    // 曾经点击过
    saveClicked: false,
    // 编辑模式下是否修改过
    hasChanged: false,
    hasGetError: false,
    loaded: false,
    loading: true,
    saveLoading: false,
    detailError: {},
    change_detail: undefined,
  },
};

export default function(
  state: types.SupplierManagementState = initState,
  action: actions.SupplierManagementActions,
): types.SupplierManagementState {
  switch (action.type) {
    case actions.GET_SUPPLIER_DETAIL: {
      return {
        ...state,
        detail: {
          ...initState.detail,
          loaded: state.detail.loaded,
          hasGetError: false,
        },
      };
    }
    case actions.GET_SUPPLIER_DETAIL_SUCCESS: {
      const supplierAttachesOriginal: any[] = _.cloneDeep(_.get(action.data, 'supplier_attaches', []));
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.data,
          supplier_attaches_origin: supplierAttachesOriginal,
          loaded: true,
          loading: false,
          hasChanged: false,
        },
      };
    }
    case actions.GET_SUPPLIER_DETAIL_FAIL: {
      return {
        ...state,
        detail: { ...state.detail, loading: false, hasGetError: true },
      };
    }
    case actions.CHANGE_DETAIL: {
      return {
        ...state,
        detail: { ...state.detail, ...action.data, hasChanged: true },
      };
    }
    case actions.SAVE_SUPPLIER_DETAIL: {
      const detail = state.detail;
      return {
        ...state,
        detail: { ...detail, saveLoading: true, saveClicked: true },
      };
    }
    case actions.SAVE_SUPPLIER_DETAIL_SUCCESS: {
      return {
        ...state,
        detail: { ...state.detail, saveLoading: false, hasChanged: false },
      };
    }
    case actions.SAVE_SUPPLIER_DETAIL_FAIL: {
      return {
        ...state,
        detail: {
          ...state.detail,
          saveLoading: false,
          detailError: _.get(action, 'error') || {},
        },
      };
    }
  }
  return state;
}
